//#region src/getShortErrorMsg.ts
var getDocsUrl = (errorCode)=>{
    return `View the docs to see how to solve: https://module-federation.io/guide/troubleshooting/${errorCode.split("-")[0].toLowerCase()}#${errorCode.toLowerCase()}`;
};
var getShortErrorMsg = (errorCode, errorDescMap, args, originalErrorMsg)=>{
    var msg = [
        `${[
            errorDescMap[errorCode]
        ]} #${errorCode}`
    ];
    args && msg.push(`args: ${JSON.stringify(args)}`);
    msg.push(getDocsUrl(errorCode));
    originalErrorMsg && msg.push(`Original Error Message:\n ${originalErrorMsg}`);
    return msg.join("\n");
};
//#endregion
exports.getShortErrorMsg = getShortErrorMsg; //# sourceMappingURL=getShortErrorMsg.cjs.map
